(function($) {
	

    if (window.matchMedia("(max-width: 767px)").matches) {
      // Viewport is less or equal to 700 pixels wide
    } else {
      // Viewport is greater than 700 pixels wide
    }


  var SELECTOR_HINT = '.hint-block .hint';
  var SELECTOR_DESC = '.hint-description';

  // 1) Перемістити всі hint-description в body 1 раз
  function mountHintDescriptions(root) {
    var $root = root ? $(root) : $(document);

    $root.find(SELECTOR_DESC).each(function () {
      var $desc = $(this);
      if ($desc.data('hintMounted')) return;

      $desc.data('hintMounted', true);
      $desc.appendTo('body');
    });
  }

  // 2) Закрити все
  function closeAllHints() {
    $(SELECTOR_DESC).removeClass('hint-hovered').hide();
    $(SELECTOR_HINT).removeData('activeDesc');
  }

  // 3) Отримати відповідний description по data-hint / data-hint-desc
  function getDescByHintId(hintId) {
    return $(SELECTOR_DESC).filter(function () {
      return String($(this).data('hint-desc')) === String(hintId);
    }).first();
  }

  // 4) Позиціонування в межах viewport (для position: fixed)
  function positionHint($desc, evt) {
    if (!$desc || !$desc.length) return;

    var pad = 15; // відступ від країв екрану
    var gap = 16; // відступ від курсора/тапа

    // clientX/Y = координати у viewport (ідеально для fixed)
    var x = (evt.clientX != null) ? evt.clientX : (evt.pageX - window.pageXOffset);
    var y = (evt.clientY != null) ? evt.clientY : (evt.pageY - window.pageYOffset);

    // тимчасово показати, щоб зчитати габарити
    $desc.css({ left: 0, top: 0, visibility: 'hidden', display: 'block' });

    var w = $desc.outerWidth();
    var h = $desc.outerHeight();
    var vw = window.innerWidth;
    var vh = window.innerHeight;

    var left = x + gap;
    var top  = y + gap;

    // clamp right/left
    if (left + w + pad > vw) left = vw - w - pad;
    if (left < pad) left = pad;

    // clamp bottom/top (якщо не влазить вниз — ставимо вверх)
    if (top + h + pad > vh) top = y - h - gap;
    if (top < pad) top = pad;

    $desc.css({ left: left + 'px', top: top + 'px', visibility: 'visible' });
  }

  // 5) Відкрити hint (показати тільки потрібний)
  function openHint($hint, evt) {
    var hintId = $hint.data('hint');
    var $desc = getDescByHintId(hintId);

    if (!$desc.length) return;

    // переносимо все в body (на випадок, якщо щойно домальовано)
    mountHintDescriptions(document);

    // показуємо лише потрібний
    $(SELECTOR_DESC).removeClass('hint-hovered').hide();
    $desc.addClass('hint-hovered').show();

    // запам’ятали активний тултіп для mousemove
    $hint.data('activeDesc', $desc);

    // позиціонуємо одразу
    positionHint($desc, evt);
  }

  // 6) INIT
  $(document).ready(function () {
    // setTimeout(function(){
    //   $('#esc-oos-form').appendTo('body');
    // },1000)

    // $(document).on('click', '#cb-fake-notify-btn', function (e) {
    //    $('#esc-oos-form').find('.NBIS-Modal__btn').click();
    // })

    mountHintDescriptions(document);
  });

  // 7) DESKTOP: hover + move + leave (делеговано — не ламається після re-render)
  $(document)
    .on('mouseenter', SELECTOR_HINT, function (e) {
      // hover на десктопі
      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        openHint($(this), e);
      }
    })
    .on('mousemove', SELECTOR_HINT, function (e) {
      var $desc = $(this).data('activeDesc');
      if ($desc && $desc.length) positionHint($desc, e);
    })
    .on('mouseleave', SELECTOR_HINT, function () {
      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        closeAllHints();
      }
    });

  // 8) MOBILE: tap toggle (делеговано)
  $(document).on('click', SELECTOR_HINT, function (e) {
    // на мобайлі відкриваємо по кліку/тапу
    if (!(window.matchMedia && window.matchMedia('(hover: hover)').matches)) {
      e.preventDefault();
      e.stopPropagation();

      var $hint = $(this);
      var hintId = $hint.data('hint');
      var $desc = getDescByHintId(hintId);

      // toggle
      if ($desc.hasClass('hint-hovered')) {
        closeAllHints();
      } else {
        openHint($hint, e);
      }
    }
  });

  // 9) Закриття по тапу поза hint/tooltip
  $(document).on('click', function (e) {
    var $t = $(e.target);
    if ($t.closest(SELECTOR_HINT).length) return;
    if ($t.closest(SELECTOR_DESC).length) return;
    closeAllHints();
  });

  // 10) Пере-перенесення після зміни варіанту / перерендеру секцій
  // (різні теми тригерять різні івенти — цей набір покриває більшість)
  $(document).on('variant:change product:rerender shopify:section:load shopify:section:reorder shopify:section:select', function () {
    mountHintDescriptions(document);
    closeAllHints();
  });

  // 11) На випадок “тихого” DOM update — MutationObserver (страховка)
  var target = document.querySelector('main') || document.body;
  var obs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (!m.addedNodes || !m.addedNodes.length) continue;

      $(m.addedNodes).each(function () {
        if (this.nodeType !== 1) return;
        if ($(this).find(SELECTOR_DESC).length || $(this).is(SELECTOR_DESC)) {
          mountHintDescriptions(this);
        }
      });
    }
  });
  obs.observe(target, { childList: true, subtree: true });


  function colorGuideTabs() {
    const content = $('.cb-color-guide-content');
      
      $('.cb-color-nav .cb-color-item').on('click', function() {
        $('.cb-color-nav .cb-color-item').removeClass('color-active');

        const colorName = $(this).data('color');

        
        if(!$(this).hasClass('color-active')) {
          $(this).addClass('color-active');
        } 


        content.each(function() {
         $(this).hide();
         $(this).find('.' + colorName).parents(content).fadeIn();
        })
      })
    if (window.matchMedia("(max-width: 767px)").matches) {
         $('.cb-color-nav .cb-color-item:first-child').click();
    } else {
       $('.cb-color-nav .swiper-slide-active').click();
    }
  }

  $('.sticky-atc-bar .product-form__submit').on('click',function(e){


      $([document.documentElement, document.body]).animate({
        scrollTop: $(".product-form .product-form__submit").offset().top - 300
    }, 400);

  })
 

    $(document).ready(function() {
	    colorGuideTabs()
    });


    // var validation
    // $('.cb-vat-company-form .float__wrapper').slideUp('fast');
    // $('input[name="private-company"]').on('change', function() {
    //   const value = $('input[name="private-company"]:checked').val();

    //   if (value === 'yes') {
    //     $('.cb-vat-company-form .float__wrapper').slideDown('fast');
    //     $('#cb-vat-number-input').attr('required', true);
    //     $('#cb-vat-number-input').attr('minlength', 6);
    //   } else {
    //     $('.cb-vat-company-form .float__wrapper').slideUp('fast');
    //     $('#cb-vat-number-input').removeAttr('required');
    //     $('#cb-vat-number-input').removeAttr('minlength');

    //     let checkoutBtn = $(this).find('button[type="submit"]');
    //     let checkoutBtnCart = $('button[form="cart"]');
    //     checkoutBtn.removeAttr('disabled');
    //     checkoutBtnCart.removeAttr('disabled');
    //     $('#cb-vat-number-input').removeClass('error');
    //     $('.cb-vat-company-form').removeClass('cb-error');
    //   }
    // });

    // $('form#cb-cart-checkout, form#cart').on('submit', function (e) {
    //   const value = $('input[name="private-company"]:checked').val();
    //   console.log(value);
    //   if (value === 'yes') {
    //     e.preventDefault();
    //     let checkoutBtn = $(this).find('button[type="submit"]');
    //     let checkoutBtnCart = $('button[form="cart"]');
    //     checkoutBtn.attr('disabled', true);
    //     checkoutBtnCart.attr('disabled', true);
    //     $('#cb-vat-number-input').removeClass('error');
    //     $('.cb-vat-company-form').removeClass('cb-error');

    //     let cartjson = $(this).data('cartjson');
    //     let cartjsonstr = JSON.stringify(cartjson);
    //     let code = $('#cb-vat-number-input').val();
    //     $.post('https://alt.cartblender.com/projects/zascha/vat_validate.php', {code: code, cartjson: cartjsonstr}).done(function(res) {
    //       res = JSON.parse(res);
    //       if (res !== null && res.isValid === true) {
    //         if (res.invoice_url !== undefined && res.invoice_url !== null) {
    //           window.location.href = res.invoice_url;
    //         } else {
    //           window.location.href = FoxTheme.routes.cart_url.replace('/cart', '/checkout');
    //         }
    //       } else {
    //         $('#cb-vat-number-input').addClass('error');
    //         $('.cb-vat-error').removeClass('cb-hidden');
    //         $('.cb-vat-company-form').addClass('cb-error');
    //         checkoutBtn.removeAttr('disabled');
    //         checkoutBtnCart.removeAttr('disabled');
    //       }
    //     });
    //   } else {
    //     let checkoutBtn = $(this).find('button[type="submit"]');
    //     let checkoutBtnCart = $('button[form="cart"]');
    //     checkoutBtn.removeAttr('disabled');
    //     checkoutBtnCart.removeAttr('disabled');
    //     $('#cb-vat-number-input').removeClass('error');
    //     $('.cb-vat-company-form').removeClass('cb-error');
    //   }
    // });
    // $('#cb-vat-number-input').blur(function(){
    //   $(this).addClass('cb-blured');
    // });
  

  

    
})(jQuery);

